<div
	class="content"
	[style.background]="background"
	[style.height]="size"
	[style.line-height]="size"
	[style.width]="size"
>
	<ng-content select="figure" />
</div>
<div class="caption"><ng-content select="figcaption" /></div>
